export default __webpack_public_path__ + "static/media/dtsu5168_direct_gw152.74241a96.jpg";